import Vue from 'vue'
import VueRouter from 'vue-router'
import Search_Home from '../components/Search_Home.vue'
import Normal_Search from '../components/normal_search/Normal.vue'
const index = () => import('../components/Search_Home.vue')

// import Door from '../components/LM_1_door/Door.vue'
const Door = () => import('../components/LM_1_door/Door.vue')

// import Policy from '../components/LM_2_policy/Policy.vue';
const Policy = () => import('../components/LM_2_policy/Policy.vue')
const FindPolicy = () => import('../components/LM_2_policy/FindPolicy.vue')


// import Work from '../components/LM_3_work/Work.vue'
const Work = () => import('../components/LM_3_work/Work.vue')

// import Open from '../components/LM_4_open/Open.vue'
const Open = () => import('../components/LM_4_open/Open.vue')

// import News from '../components/LM_5_news/News.vue'
const News = () => import('../components/LM_5_news/News.vue')

import Interact from '../components/LM_6_interact/Interact.vue'
// const Interact = () => import('../components/LM_6_interact/Interact.vue')

import Enter from '../components/LM_7_enterInnerMongolia/Enter.vue'
// const Enter = () => import('../components/LM_7_enterInnerMongolia/EnterInnerMongolia.vue')

// import Wechat from '../components/LM_8_wechat/Wechat.vue'
const Wechat = () => import('../components/LM_8_wechat/Wechat.vue')

// import Pic from '../components/LM_9_pic/Pic.vue'
const Pic = () => import('../components/LM_9_pic/Pic.vue')

// import Video from '../components/LM_10_video/Video.vue'
const Video = () => import('../components/LM_10_video/Video.vue')

// // import Department from '../components/LM_11_department/Department.vue';
// const Department = () => import('../components/LM_11_department/Department.vue')

// import City from '../components/LM_12_city/City.vue';
const City = () => import('../components/LM_12_city/City.vue')

// // import Webs from '../components/LM_13_webs/Webs.vue'
// const Webs = () => import('../components/LM_13_webs/Webs.vue')

// import PolicySearch from '../components/LM_2_policy/PolicySearch.vue'
const PolicySearch = () => import('../components/LM_2_policy/PolicySearch.vue')

// import Policy_File from '../components/policy_file/PolicyFile.vue';
const Policy_File = () => import('../components/policy_file/PolicyFile.vue')

const Gb = () => import('../components/LM_14_gb/Gb.vue')

const ZhaoZhengCe = () => import('../components/ZhaoZhengCe/findPolicy.vue')


import test from '../components/table/table_gb.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Door'
  },
  {
    path: '/index',
    component: index
  },
  {
    path: '/Search_Home',
    component: Search_Home
  },

  {
    path: '/test',
    component: test
  },

  {
    path: '/Normal_search',
    component: Normal_Search,
    redirect: '/Door',
    children: [
      {
        name: 'door',
        path: '/Door',
        component: Door
      },
      {
        name: 'policy',

        path: '/Policy',
        component: Policy
      },
      {
        path: '/FindPolicy',
        component: FindPolicy
      },
      {
        name: 'work',

        path: '/Work',
        component: Work
      },
      {
        name: 'open',

        path: '/Open',
        component: Open
      },
      {
        name: 'gb',

        path: '/Gb',
        component: Gb
      },
      {
        name: 'news',

        path: '/News',
        component: News
      },
      {
        name: 'interact',

        path: '/Interact',
        component: Interact
      },
      {
        name: 'enter',

        path: '/Enter',
        component: Enter
      },
      {
        name: 'wechat',

        path: '/Wechat',
        component: Wechat
      },
      {
        name: 'pic',

        path: '/Pic',
        component: Pic
      },
      {
        name: 'video',

        path: '/Video',
        component: Video
      },
      // {
      //   path: '/Department',
      //   component: Department
      // },
      {
        name: 'city',
        path: '/City',
        component: City
      },
      // {
      //   path: '/Webs',
      //   component: Webs
      // },



      {
        path: '/PolicySearch',
        component: PolicySearch
      },
      {
        path: '/Policy_File',
        component: Policy_File
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
